/* istanbul ignore file */
import React, { Dispatch, SetStateAction } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import { translate } from 'containers/services/translate';
import { formsAreValidated } from 'containers/services/validateForm';
import { Grid } from '@material-ui/core';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { FormContainer } from 'containers/CourtManagerLegalProceedings/styled-components';
import VictimFormComponent from 'containers/CourtManagerLegalProceedings/AddVictimsDrawer/VictimForm';
import {
  victimUsageValidator,
  victimValidator,
} from 'containers/RecapManagerPage/VictimDrawer';
import { VictimForm } from 'containers/CourtManagerLegalProceedings/typings';
import { Listings } from 'containers/AppContainer/typings';
import SahamDrawer from 'components/SahamDrawer';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { CLAIM_STATUS } from 'containers/data-structure';
import {
  isUniqueCinAddedVictims,
  checkClassVictims,
  checkVictimsAge,
} from 'containers/PreOpeningPage/utils';
import { PROFESSION_CODES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import {
  addPriorityReasonProfession,
  removeDeletedItems,
} from 'services/utils';
import { VictimType } from 'typings/globalTypes';
import { formatVictimsToAdd } from 'containers/CourtManagerLegalProceedings/AddVictimsDrawer/utils';
import { OPENING_STATE } from 'services/constants';

export interface AddVictimDrawerProps {
  intl: IntlShape;
  listings: Listings;
  claimId: number;
  victimFormValues: { [key: string]: VictimType };
  setVictimFormValues: Dispatch<SetStateAction<{ [key: string]: VictimForm }>>;
  addVictimForm: () => void;
  handleToggleDrawer: Function;
  requestCreateVictim?: Function;
  open: boolean;
  dataClaimToUpdate?: any;
  setDataClaimToUpdate?: Function;
  isOpeningManager?: boolean;
  setClaimRecap?: Function;
  claimRecap?: any;
  isDrawerAdd?: boolean;
}
const AddVictimDrawer: React.FC<AddVictimDrawerProps> = (
  props,
): JSX.Element => {
  const { victimFormValues, setVictimFormValues } = props;
  const [victimValidation, setVictimValidation] = React.useState({});

  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );

  const setOneFormValuesVictim = (id: string) => (
    newVictimFormValue: VictimForm,
  ) => {
    setVictimFormValues(prevVictimFormValues => ({
      ...prevVictimFormValues,
      [id]: newVictimFormValue,
    }));
  };
  const successCallBackAddVictims = () => {
    toast.success(translate(messages.successDialogAddVictims, props));
    props.handleToggleDrawer();
  };
  const isUsageOpening =
    get(props.claimRecap, 'claim.openingState', null) ===
      OPENING_STATE.NOT_COMPLETED &&
    featureService.hasFeature(FEATURES.OPENING_BY_USAGE);
  const handleCreateVictim = () => {
    if (props.requestCreateVictim) {
      let isFormValid = false;
      const victimValues = Object.values(victimFormValues);
      [...Object.values(victimFormValues)].map((el: any) => {
        const validator =
          (isUsageOpening ? victimUsageValidator(el) : victimValidator(el)) ||
          {};
        setVictimValidation(validator);
        if (formsAreValidated(validator ? validator : {})) {
          isFormValid = true;
        }
      });

      if (
        isUsageOpening
          ? isFormValid
          : isFormValid &&
            isUniqueCinAddedVictims(
              get(props.claimRecap, 'victims'),
              (victimValues as unknown) as VictimType[],
              get(props.claimRecap, 'claim.lossDate'),
            )
      ) {
        const addedVictimFormValues = formatVictimsToAdd(
          (victimValues as unknown) as VictimType[],
          props.claimId,
          get(props.claimRecap, 'claim.openingState', null),
        );
        if (props.isOpeningManager) {
          props.setDataClaimToUpdate &&
            props.setDataClaimToUpdate({
              ...props.dataClaimToUpdate,
              victims: [
                ...get(props.dataClaimToUpdate, 'victims', []),
                ...addedVictimFormValues,
              ],
            });
          props.setClaimRecap &&
            props.setClaimRecap({
              ...props.claimRecap,
              victims: [
                ...get(props.claimRecap, 'victims', []),
                ...removeDeletedItems(addedVictimFormValues).map((el: any) => {
                  return { ...el, decision: null };
                }),
              ],
            });
          return props.handleToggleDrawer();
        }
        props.requestCreateVictim(
          {
            victimsSagisToAdd: [],
            victimsCorpoToAdd: addedVictimFormValues,
            priorityReasonId: addPriorityReasonProfession(
              priorityReasonClaimId,
              !!addedVictimFormValues.find((v: any) =>
                PROFESSION_CODES.includes(v.professionCode),
              ),
              props.listings,
            ),
            isCourtMonitoringManager: true,
            claimDetails: isUsageOpening
              ? {}
              : {
                  status: CLAIM_STATUS.PENDING_INFO_MODIFICATION,
                },
            isTrackingActive: featureService.hasFeature(
              FEATURES.TRACKING_ACTIONS_USER,
            ),
            claimId: props.claimId,
          },
          successCallBackAddVictims,
        );
      }
    }
  };

  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate({ ...messages.addVictim }, props)}
      confirmButtonTitle={'Enregister'}
      handleValidateDrawer={handleCreateVictim}
      isSaveButtonDisabled={
        !isUniqueCinAddedVictims(
          get(props.claimRecap, 'victims', []),
          (Object.values(victimFormValues) as unknown) as VictimType[],
          get(props.claimRecap, 'claim.lossDate'),
        ) ||
        checkClassVictims(
          [...Object.values(victimFormValues)],
          get(props.claimRecap, 'claim.lossDate'),
        ) ||
        checkVictimsAge(
          [...Object.values(victimFormValues)],
          get(props.claimRecap, 'claim.lossDate'),
        )
      }
    >
      <FormContainer>
        <Grid container direction="column" spacing={2}>
          <Grid container direction="row" spacing={3}>
            <Grid item xs={12}>
              {Object.keys(victimFormValues).map(
                (key: string, index: number) => (
                  <VictimFormComponent
                    nbr={index + 1}
                    listings={props.listings}
                    formValues={victimFormValues[key]}
                    setFormValues={setOneFormValuesVictim(key)}
                    victimValidation={victimValidation}
                    claimRecap={props.claimRecap}
                    isDrawerAdd={props.isDrawerAdd}
                  />
                ),
              )}
            </Grid>
          </Grid>
        </Grid>
      </FormContainer>
    </SahamDrawer>
  );
};

export default injectIntl(AddVictimDrawer);
